<script>
  import { Line } from 'vue-chartjs'

  export default {
    name: "LineChart",
    extends: Line,
    data () {
      return {
        chartData: {
          labels: [],
          datasets: [{
              label: this.$t('Cluster publications'),
              data: [],
              fill: false,
              borderColor: '#0077C8'
            },
            {
              label: this.$t('Avg publications / cluster'),
              data: [],
              fill: false,
              borderColor: '#888',
              borderDash: [10, 5],
            },
            {
              type: 'bar',
              label: this.$t('One year relative growth'),
              data: [],
              backgroundColor: []
            }],
        },
        options: {
          elements: {
            point:{
              radius: 0
            }
          },
          legend: {
            display: true,
            position: 'bottom',
            align: 'start'
          },
          responsive: true,
          maintainAspectRatio: true,
          scales: {
            xAxes: [{
                ticks: {
                    display: true,
                    maxRotation: 60,
                    minRotation: 60
                }
            }]
          }
        }
      }
    },
    methods: {
      get_anys_quesito: function() {
        let cluster = this.$store.getters.cluster_marcat;
        let num_clusters = this.$store.getters.clusters.length-1;
        let nodes = this.$store.state.graf_actual.nodes;
        let any_ini = parseInt(this.$store.getters.any_actual[0]);
        let any_fin = parseInt(this.$store.getters.any_actual[1]);

        let yr_clust_publ = [];
        let yr_mean_publ_clust = [];
        for (let i = 0; i < any_fin-any_ini+1; i++) { yr_clust_publ[i] = 0; yr_mean_publ_clust[i] = 0; }

        for (let i = 0; i < nodes.length; i++){
          let node_yr = parseInt(nodes[i].date.substring(0,4))
          if (cluster == nodes[i].cluster) { yr_clust_publ[node_yr-any_ini] ++; }
          //descartem undefined per tal de no desvirtuar les dades
          if (nodes[i].muntanya !== "undefined") { yr_mean_publ_clust[node_yr-any_ini] ++; }
        }

        // First year:
        let relative_growth = [0];
        let yr_labels = [ String(any_ini) ];
        this.chartData.datasets[2].backgroundColor = [ '' ];
        yr_mean_publ_clust[0] = (yr_mean_publ_clust[0] / num_clusters).toFixed(2);
        let growth_legend_color_choice = 0;

        // Rest of years
        for (let i = 1; i < any_fin-any_ini+1; i++) {
          yr_labels[i] = String(any_ini+i);
          yr_mean_publ_clust[i] = (yr_mean_publ_clust[i] / num_clusters).toFixed(1);
          // comparison between the slope of the publications in cluster and slope of the mean in all cluster 
          // ( as the year increment is one, slope: (yf-yi)/(x+1 - x) <=> (yf-yi) )
          relative_growth[i] = ((yr_clust_publ[i] - yr_clust_publ[i-1]) - (yr_mean_publ_clust[i] - yr_mean_publ_clust[i-1])).toFixed(2);
          if (relative_growth[i] > 0) {
            this.chartData.datasets[2].backgroundColor[i] = '#90EE90';
            growth_legend_color_choice ++;
          } else {
            this.chartData.datasets[2].backgroundColor[i] = '#FFCCCB';
            growth_legend_color_choice --;
          }
        }
        // Legend takes the color of first element in list. And we don't mind the first color because growth is 0.
        //  We use it to set the color of the legend to the one that is predominant
        this.chartData.datasets[2].backgroundColor[0] = growth_legend_color_choice >= 0 ? '#90EE90' : '#FFCCCB';

        this.chartData.labels = yr_labels;
        this.chartData.datasets[0].data = yr_clust_publ;
        this.chartData.datasets[1].data = yr_mean_publ_clust;   
        this.chartData.datasets[2].data = relative_growth;
        this.renderChart(this.chartData, this.options);
      }
    },
    mounted() {
      console.log("arribo al Linechart")
      this.$root.$on('LineChart', this.get_anys_quesito);
    },
    beforeDestroy() {
        console.log("mato al LineChart")
        this.$root.$off('LineChart', this.get_anys_quesito);
    } 
  }
</script>
